// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.highlightTextarea {
  position: relative;
  width: 100%;
}

.highlightTextarea .highlightTextarea-container {
  position: absolute;
  margin: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.highlightTextarea .highlightTextarea-highlighter {
  position: absolute;
  z-index: 1;
  border: none;
  margin: 0;
  color: transparent;
  cursor: text;
  overflow: hidden;
  white-space: pre-wrap;
  word-wrap: break-word;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-family: inherit;
  font-size: inherit;
}

.highlightTextarea textarea,
.highlightTextarea input {
  position: relative;
  z-index: 2;
  left: 0;
  top: 0;
  resize: none;
  white-space: pre-wrap;
  word-wrap: break-word;
  background: transparent;
  width: 100%;
  height: 100%;
  font-family: inherit;
  font-size: inherit;
}

/* Debug mode for highlighter */
.highlightTextarea.debug .highlightTextarea-highlighter {
  color: #f00;
  border: 1px solid #f00;
  margin: -1px;
}

/* Style adjustments for marks */
.highlightTextarea mark {
  line-height: inherit;
  color: transparent;
  margin: 0;
  padding: 0;
}

/* Resizable settings */
.highlightTextarea .ui-wrapper {
  margin: 0 !important;
}

.highlightTextarea .ui-resizable-se {
  bottom: 15px;
  right: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/@_utils/highlightTextArea/jquery.highlighttextarea.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,MAAM;EACN,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ","sourcesContent":[".highlightTextarea {\n  position: relative;\n  width: 100%;\n}\n\n.highlightTextarea .highlightTextarea-container {\n  position: absolute;\n  margin: 0;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\n\n.highlightTextarea .highlightTextarea-highlighter {\n  position: absolute;\n  z-index: 1;\n  border: none;\n  margin: 0;\n  color: transparent;\n  cursor: text;\n  overflow: hidden;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  font-family: inherit;\n  font-size: inherit;\n}\n\n.highlightTextarea textarea,\n.highlightTextarea input {\n  position: relative;\n  z-index: 2;\n  left: 0;\n  top: 0;\n  resize: none;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  background: transparent;\n  width: 100%;\n  height: 100%;\n  font-family: inherit;\n  font-size: inherit;\n}\n\n/* Debug mode for highlighter */\n.highlightTextarea.debug .highlightTextarea-highlighter {\n  color: #f00;\n  border: 1px solid #f00;\n  margin: -1px;\n}\n\n/* Style adjustments for marks */\n.highlightTextarea mark {\n  line-height: inherit;\n  color: transparent;\n  margin: 0;\n  padding: 0;\n}\n\n/* Resizable settings */\n.highlightTextarea .ui-wrapper {\n  margin: 0 !important;\n}\n\n.highlightTextarea .ui-resizable-se {\n  bottom: 15px;\n  right: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
